"use strict";

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var Markdown, React, marked;

marked = require("marked");

React = require("react");

Markdown = React.createClass({
  displayName: "Markdown",

  propTypes: {
    value: React.PropTypes.string,
    alt: React.PropTypes.string
  },
  getDefaultProps: function getDefaultProps() {
    return {
      alt: ""
    };
  },
  html: function html() {
    if (this.props.value) {
      return marked(this.props.value);
    } else {
      return this.props.alt;
    }
  },
  render: function render() {
    return React.createElement("div", _extends({}, this.props, { dangerouslySetInnerHTML: { __html: this.html() } }));
  }
});

module.exports = Markdown;


/*****************
 ** WEBPACK FOOTER
 ** ./lib/utils/markdown.js
 ** module id = 581
 ** module chunks = 0
 **/